import { Card, CardContent, Grid, Typography } from '@mui/material';

export default function VentasResumen({ ventas }) {
  const activas = ventas.filter(v => v.estado === 'ACTIVA');

  const total = activas.reduce(
    (sum, v) => sum + Number(v.monto),
    0
  );

  return (
    <Grid container spacing={2} sx={{ mb: 2 }}>
      <Grid item xs={6}>
        <Card>
          <CardContent>
            <Typography>Total Ventas</Typography>
            <Typography variant="h5">{total.toFixed(2)}</Typography>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={6}>
        <Card>
          <CardContent>
            <Typography>Ventas Activas</Typography>
            <Typography variant="h5">{activas.length}</Typography>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
}
